import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProductDepartmentResponseModel } from '../../../shared/models/response-models/product-department-response.model';
import { SupplierResponseModel } from '../../../shared/models/response-models/supplier-response.model';
import { WeekColorResponseModel } from '../../../shared/models/response-models/week-color-response.model';
import {
  SharedBrandsResponse,
  SharedProductCategoriesResponse,
  SharedUnitsResponse,
} from '../../../shared/models/shared.model';
import { HttpParamsService } from '../../../shared/services/http-params.service';

@Injectable({
  providedIn: 'root',
})
export class WorkService {
  private baseUrl = environment.inventoryApiUrl;
  private produtionSystemApiBaseUrl = environment.productionSystemApiBaseUrl;
  private readonly GET_ALL_PRODUCT_CATEGORIES = (): string => `${this.baseUrl}/ProductCategories`;
  private readonly GET_ALL_UNITS = (): string => `${this.baseUrl}/Units`;
  constructor(
    private http: HttpClient,
    private httpParamsService: HttpParamsService,
  ) {}

  formatDateOnly(date: any): string | null {
    if (!date) return null;
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  }

  formatDate(date: string | undefined): string | undefined {
    if (!date) return undefined;

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  getSuppliers(companyId: number) {
    return this.http.get<SupplierResponseModel[]>(
      `${this.baseUrl}/suppliers?CompanyId=${companyId}`,
    );
  }

  getProductDepartments(companyId: number): Observable<ProductDepartmentResponseModel[]> {
    return this.http.get<ProductDepartmentResponseModel[]>(
      `${this.baseUrl}/ProductDepartments?CompanyId=${companyId}`,
    );
  }

  getProductCategories(
    queryParams: Record<string, any>,
  ): Observable<SharedProductCategoriesResponse[]> {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<SharedProductCategoriesResponse[]>(this.GET_ALL_PRODUCT_CATEGORIES(), {
      params,
    });
  }

  getPastProductionCycles(companyId: number): Observable<WeekColorResponseModel[]> {
    const url = `${this.produtionSystemApiBaseUrl}/ProductionCycle?CompanyID=${companyId}`;
    return this.http.get<WeekColorResponseModel[]>(url);
  }

  getSharedUnits(queryParams: Record<string, any>): Observable<SharedUnitsResponse[]> {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<SharedUnitsResponse[]>(this.GET_ALL_UNITS(), {
      params,
    });
  }

  getBrands(companyId: number): Observable<SharedBrandsResponse[]> {
    return this.http.get<SharedBrandsResponse[]>(`${this.baseUrl}/Brands?CompanyId=${companyId}`);
  }
}
